import { ColumnType, ColumnsType } from '../types/SectionCompletionTypes'

import { CheckedItens } from '../types/CheckedItens'
import { ConstantsImport } from '../constants/ConstantsImport'
import { InterventionFileType } from '../types/InterventionFileType'
import MathUtil from './MathUtil'
import { RigImport } from '../types/RigImport'
import { WellCard } from '../types/WellCard'
import { WellFile } from '../types/WellTypes'
import { WellFileImport } from '../types/WellFileImport'
import _ from 'lodash'
import i18n from 'live/services/i18n'
import typeImages from 'plugin-liverig/shared/enums/TypeImages'

const convertWell = (
    wellFile: WellFile,
    oilField: any,
    wellCard: WellCard,
    typeAsset: TypeAsset,
    phaseOptions: any
): WellFileImport => {
    const wellFileImport: WellFileImport = ConstantsImport.emptyWellFileImport
    if (!wellFile || !wellFile.revision || !wellFile.revision.content || !wellFile.revision.content.input) {
        return wellFileImport
    }

    wellFileImport.wellCard = wellCard
    const LDA = wellFile.revision.content.input.lda || 0

    if (wellFile.revision.content.input) {
        wellFileImport.description.water_depth = LDA // lamina dagua
        if (wellFile.revision.content.input.phases && wellFile.revision.content.input.phases.length > 0) {
            const phases = wellFile.revision.content.input.phases

            // Well - Description (1)
            if (wellCard.description && typeAsset === 'well') {
                wellFileImport.description.final_depth = _.last(phases).final_md
            } // profundidade final do poço

            wellFileImport.description.rotaryTable = wellFile.revision.content.input.airgap || 0

            // Well - Sections (3)
            if (wellCard.sections) {
                if (Array.isArray(phases) && phases.length > 0) {
                    wellFileImport.sections.sections = phases
                        ?.filter((entry, index) => phaseOptions?.[index]?.shouldImport || typeAsset === 'well')
                        ?.map((element, index) => {
                            let casingDiameter = ''
                            let bitSize = ''
                            let casingHangerMd = null
                            let isThereLinerHangerMd = null
                            let linerType = null
                            let linerTopOfCementMd = null
                            const columns = element?.columns

                            const drillingFluids = []
                            drillingFluids.push({})
                            drillingFluids[0].type = i18n(element.drilling_fluid_type)
                            drillingFluids[0].density = element.drilling_fluid_density

                            const wellbores = []
                            const drillStrings = []
                            const BHAs = []

                            let createRun = false

                            if (columns['1'] == null && columns['3'] == null && columns['4'] == null) {
                                const wellbore: WellBore = {}

                                wellbore.type = 'open_hole'

                                wellbores.push(wellbore)
                            }

                            for (const prop in columns) {
                                switch (columns[prop]?.type) {
                                    case 'casing string': {
                                        if (phaseOptions?.[index]?.[prop]?.shouldIgnore) break
                                        for (const valueIndex in columns[prop]?.values) {
                                            const value = columns[prop]?.values[valueIndex]
                                            const wellbore: WellBore = {}
                                            if (
                                                value.material?.type === 'CASING' ||
                                                value?.material?.type?.toLowerCase().startsWith('revestimento')
                                            ) {
                                                wellbore.type = 'Casing'

                                                wellbore.outer_diameter = value?.material?.OD
                                                casingDiameter =
                                                    casingDiameter > value.material.OD
                                                        ? casingDiameter
                                                        : value.material.OD
                                                wellbore.inner_diameter = value?.material?.ID

                                                wellbore.final_md = value?.final_md
                                                wellbore.start_md = value?.initial_md
                                            }

                                            wellbores.push(wellbore)
                                        }
                                        break
                                    }

                                    case 'drill string': {
                                        const dsValues = []
                                        const bhaValues = []

                                        if (!phaseOptions?.[index]?.[prop]?.shouldIgnore) createRun = true

                                        for (const valueIndex in columns[prop].values) {
                                            const value = columns[prop].values[valueIndex]
                                            const drillString: DrillStringData = {}
                                            const BHA: BHAData = {}

                                            if (value.material?.type === 'DRILL_PIPE') {
                                                drillString.component_type = 'Drill Pipe'
                                                drillString.component_id = value.material.id

                                                drillString.outer_diameter = value.material.OD
                                                drillString.inner_diameter = value.material.ID

                                                drillString.final_md = value.final_md
                                                drillString.start_md = value.initial_md
                                                drillString.length = value.length

                                                dsValues.push(drillString)
                                            } else if (value.material?.type === 'BHA') {
                                                BHA.component_type = 'Other'
                                                BHA.component_id = value.material.id
                                                BHA.outer_diameter = value.material.OD
                                                BHA.inner_diameter = value.material.ID

                                                BHA.final_md = value.final_md
                                                BHA.start_md = value.initial_md
                                                BHA.length = value.length

                                                bhaValues.push(BHA)
                                            }
                                        }

                                        drillStrings.push({ values: bhaValues })
                                        BHAs.push({ values: bhaValues })

                                        bitSize = columns[prop].bit_size || columns[prop].bitSize
                                        break
                                    }

                                    case 'liner': {
                                        if (phaseOptions?.[index]?.[prop]?.shouldIgnore) break
                                        for (const valueIndex in columns[prop].values) {
                                            const value = columns[prop].values[valueIndex]
                                            const wellbore: WellBore = {}

                                            if (
                                                value.material?.type === 'CASING' ||
                                                value?.material?.type?.toLowerCase().startsWith('revestimento')
                                            ) {
                                                wellbore.type = 'liner'

                                                wellbore.outer_diameter = value.material.OD
                                                casingDiameter =
                                                    casingDiameter > value.material.OD
                                                        ? casingDiameter
                                                        : value.material.OD
                                                wellbore.inner_diameter = value.material.ID

                                                wellbore.final_md = value.final_md
                                                wellbore.start_md = value.initial_md
                                                isThereLinerHangerMd = false
                                                casingHangerMd = columns[prop].liner_hanger_md
                                            }

                                            wellbores.push(wellbore)
                                        }
                                        break
                                    }

                                    case 'tie back': {
                                        if (phaseOptions?.[index]?.[prop]?.shouldIgnore) break
                                        for (const valueIndex in columns[prop].values) {
                                            const value = columns[prop].values[valueIndex]
                                            const wellbore: WellBore = {}

                                            if (
                                                value.material?.type === 'CASING' ||
                                                value?.material?.type?.toLowerCase().startsWith('revestimento')
                                            ) {
                                                wellbore.type = 'liner'
                                                linerType = 'tieback'

                                                wellbore.outer_diameter = value.material.OD
                                                casingDiameter =
                                                    casingDiameter > value.material.OD
                                                        ? casingDiameter
                                                        : value.material.OD
                                                wellbore.inner_diameter = value.material.ID

                                                wellbore.final_md = value.final_md
                                                wellbore.start_md = value.initial_md
                                                isThereLinerHangerMd = true
                                                linerTopOfCementMd = columns[prop].internal_cement_top_depth
                                            }

                                            wellbores.push(wellbore)
                                        }
                                        break
                                    }

                                    case 'scab liner': {
                                        if (phaseOptions?.[index]?.[prop]?.shouldIgnore) break
                                        for (const valueIndex in columns[prop].values) {
                                            const value = columns[prop].values[valueIndex]
                                            const wellbore: WellBore = {}

                                            if (
                                                value.material?.type === 'CASING' ||
                                                value?.material?.type?.toLowerCase().startsWith('revestimento')
                                            ) {
                                                wellbore.type = 'liner'
                                                linerType = 'scab_liner'

                                                wellbore.outer_diameter = value.material.OD
                                                casingDiameter =
                                                    casingDiameter > value.material.OD
                                                        ? casingDiameter
                                                        : value.material.OD
                                                wellbore.inner_diameter = value.material.ID

                                                wellbore.final_md = value.final_md
                                                wellbore.start_md = value.initial_md
                                                isThereLinerHangerMd = true
                                                linerTopOfCementMd = columns[prop].internal_cement_top_depth
                                            }

                                            wellbores.push(wellbore)
                                        }
                                        break
                                    }

                                    case 'work string': {
                                        break
                                    }

                                    default: {
                                        console.log('Pocoweb/ConversionUtil.js: column[prop] type not defined')
                                    }
                                }
                            }

                            return {
                                bit_diameter: bitSize,
                                casing_diameter: casingDiameter,
                                final_md: element.final_md,
                                fluid_type: i18n(element.drilling_fluid_type),
                                md_casing_shoe: element.shoe_md,
                                top_of_cement: element.internal_cement_top_depth,
                                fluid_weight: element.drilling_fluid_density,
                                liner_type: linerType,
                                liner_hanger_md: casingHangerMd && isThereLinerHangerMd ? casingHangerMd : null,
                                casing_hanger_md: casingHangerMd === null ? null : casingHangerMd,
                                liner_top_of_cement_md: linerTopOfCementMd,
                                well_bores: wellbores,
                                runs: createRun
                                    ? [
                                          {
                                              drill_strings: drillStrings,
                                              BHAs: BHAs,
                                              drilling_fluids: drillingFluids,
                                              type: 'drilling'
                                          }
                                      ]
                                    : null
                            }
                        })
                }
            }
        }
    }

    // Well - Location (2)
    if (wellCard.location && typeAsset === 'well') {
        if (
            wellFile.revision.content.input &&
            wellFile.revision.content.input.location &&
            wellFile.revision.content.input.location.wellhead
        ) {
            if (wellFile.revision.content.input.location.wellhead.latitude) {
                wellFileImport.location.latitude = MathUtil.toFixed(
                    wellFile.revision.content.input.location.wellhead.latitude,
                    7
                )
            } // lat

            if (wellFile.revision.content.input.location.wellhead.longitude) {
                wellFileImport.location.longitude = MathUtil.toFixed(
                    wellFile.revision.content.input.location.wellhead.longitude,
                    7
                )
            } // long

            wellFileImport.location.region = wellFile.revision.content.input.location.name
        }

        if (oilField && oilField.name) wellFileImport.location.field = oilField.name
    }

    // GeoPressure (4)
    if (wellCard.pressures) {
        const fractureFile = wellCard.selectedPorePressure

        if (
            wellFile.revision.content.input.geo_tables &&
            wellFile.revision.content.input.geo_tables.fracture_pressure &&
            wellFile.revision.content.input.geo_tables.fracture_pressure[fractureFile]
        ) {
            const fracturePressureArray = wellFile.revision.content.input.geo_tables.fracture_pressure[fractureFile]

            wellFileImport.pressures.fracture = fracturePressureArray.values?.map(
                (element: { elevation: string; pressure: string }) => {
                    return {
                        quota: element.elevation,
                        md: element.elevation,
                        pressure: element.pressure
                    }
                }
            )
        }

        const poreFile = wellCard.selectedFracturePressure

        if (
            wellFile.revision.content.input.geo_tables &&
            wellFile.revision.content.input.geo_tables.pore_pressure &&
            wellFile.revision.content.input.geo_tables.pore_pressure[poreFile]
        ) {
            const porPressureArray = wellFile.revision.content.input.geo_tables.pore_pressure[poreFile]

            wellFileImport.pressures.pore = porPressureArray.values?.map(
                (element: { elevation: string; pressure: string }) => {
                    return {
                        quota: element.elevation,
                        md: element.elevation,
                        pressure: element.pressure
                    }
                }
            )
        }
    }

    // Well - Trajectory (5)
    if (wellCard.trajectory) {
        if (wellFile.revision.content.input && wellFile.revision.content.input.trajectory) {
            const points = wellFile.revision.content.input.trajectory.points

            if (Array.isArray(points) && points.length > 0) {
                wellFileImport.trajectory.trajectory = points?.map(element => {
                    return {
                        md: element.md,
                        inclination: element.inclination,
                        azimuth: element.azimuth,
                        tvd: element.tvd,
                        horizontalDisplacement: element.displacement
                    }
                })
            }
        }
    }

    // Well - Temperatures (6)
    wellFileImport.temperatures.water_depth = []
    wellFileImport.temperatures.profile = []
    if (wellCard.temperatures) {
        if (wellFile.revision.content.input && wellFile.revision.content.input.temperature) {
            // lamina dagua
            const waterDepthPoints = wellFile.revision.content.input.temperature.points

            if (Array.isArray(waterDepthPoints) && waterDepthPoints.length > 0) {
                waterDepthPoints.forEach(point => {
                    if (point.elevation > -LDA) {
                        wellFileImport.temperatures.water_depth.push({
                            quota: point.elevation,
                            md: point.elevation,
                            temperature: point.temperature
                        })
                    } else {
                        wellFileImport.temperatures.profile.push({
                            quota: point.elevation,
                            md: point.elevation,
                            temperature: point.temperature
                        })
                    }
                })
            }
        }
    }

    wellFileImport.imported = true

    // Well - lithology (7)
    if (wellCard.lithology) {
        wellFileImport.lithology = wellFile?.revision?.content?.input?.lithology
        const lithologyRocks = wellFileImport.lithology?.rocks
        if (lithologyRocks) {
            wellFileImport.lithology.rocks = removeEquals(lithologyRocks, it => it.base_elevation)

            if (wellFileImport.wellCard.sumAirGap) {
                const airGap = wellFileImport.description?.rotaryTable || 0
                wellFileImport.lithology.rocks = wellFileImport.lithology.rocks.map(item => {
                    return {
                        ...item,
                        base_md: item.base_md + airGap,
                        base_elevation: item.base_elevation + airGap,
                        top_md: item.top_md + airGap,
                        top_elevation: item.top_elevation + airGap
                    }
                })
            }
        }
    }

    return wellFileImport
}

const removeEquals = (data: Array<Object>, key) => {
    return [...new Map(data.map(x => [key(x), x])).values()]
}

export const convertRigBopFile = (file: RigImport): { description: Object; BOPInfo: Object } => {
    return {
        // rigInfo
        description: {
            name: file.name,
            type: file.rig_type,
            company: file.company,
            airGap: file.airgap,
            maxWaterDepth: file.max_lda,
            pumpMaxPressure: file.max_pump_pressure,
            maxDrilledDepth: file.max_final_md,
            riserDiameter: file.riser_diameter,
            topDriveCapacity: file.top_drive_capacity,
            mudPumps: file.number_pumps
            // derrickHeight: '',
            // derrickBase: '',
            // maxMudPumpsSystemPressure: '',
            // topDriveWeight: '',
            // topDriveMaxTorque: '',
            // rotaryTableCapacity: '',
            // rotaryTableMaxTorque: '',
            // travellingBlockCapacity: '',
            // travellingBlockWeight: '',
            // maximumRiserDepth: '',
            // extra: {}
        },
        BOPInfo: {
            model: file.bop,
            maxPressure: file.bop_max_pressure,
            annularPreventerMaxPressure: file.bop_annular_max_pressure,
            floatingStackBOPWeight: file.bop_floated_stack_weight,
            BOPStackHeight: file.bop_stack_height,
            LMRPFloatingWeight: file.bop_floated_lmrp_weight,
            LMRPFloatingHeight: file.bop_lmrp_height
        }
    }
}

export const convertCompletionAbandonment = (
    file: InterventionFileType,
    checkedItens: CheckedItens,
    wellFileImport: WellFileImport
): Record<string, any> => {
    const abandonment = file.abandonment
    const completion = file.completion
    const copCoi = file.copcoi
    const completionImportInfo: any = {}

    // generalInfo
    if ((checkedItens.completion || checkedItens.all) && (completion || file.completion_type || file.well_type)) {
        completionImportInfo.general = {
            ...completion,
            completion_type: file.completion_type,
            well_type: file.well_type
        }
    }

    // copCoi
    if ((checkedItens.copCoi || checkedItens.all) && copCoi) {
        completionImportInfo.copCoi = copCoi
    }

    // Stimulation
    if ((checkedItens.stimulation || checkedItens.all) && completion) {
        completionImportInfo.stimulation = completion.stimulation
    }

    // anmBap
    if ((checkedItens.anmBap || checkedItens.all) && abandonment) {
        completionImportInfo.anmBap = {
            bap_model: abandonment.bap_model,
            anm_model: abandonment.anm_model,
            bap_tag: abandonment.bap_tag,
            anm_fluid_temperature: abandonment.anm_fluid_temperature,
            corrosion_cover: abandonment.corrosion_cover,
            wear_plug: abandonment.wear_plug
        }
    }

    // perforationElements
    if ((checkedItens.perforation || checkedItens.all) && abandonment) {
        completionImportInfo.perforation = {}
        if (abandonment.cement_plugs && abandonment.cement_plugs?.length > 0) {
            completionImportInfo.perforation.cement_plugs = abandonment.cement_plugs
        }
        if (abandonment.packers && abandonment.packers?.length > 0) {
            completionImportInfo.perforation.packers = abandonment.packers
        }
        if (abandonment.canhoneio && abandonment.canhoneio?.length > 0) {
            completionImportInfo.perforation.canhoneio = abandonment.canhoneio
        }
        if (abandonment.pip_tags && abandonment.pip_tags?.length > 0) {
            completionImportInfo.perforation.pip_tags = abandonment.pip_tags
        }
        if (abandonment.remainings && abandonment.remainings?.length > 0) {
            completionImportInfo.perforation.remainings = abandonment.remainings
        }
    }

    // abandonment
    if ((checkedItens.abandonment || checkedItens.all) && abandonment) {
        completionImportInfo.abandonment = { ...abandonment, abandonment_type: abandonment.type }
    }

    // Columns
    if ((checkedItens.superiorColumn || checkedItens.inferiorColumn || checkedItens.all) && copCoi) {
        const columns: ColumnsType = _.clone(completionImportInfo.columns) || {}

        if (checkedItens.superiorColumn) {
            const superiorColumns: Array<ColumnType> = copCoi.superior
            columns.columns_superior = [
                {
                    name: i18n('Column 1'),
                    elements: convertColumns(superiorColumns)
                }
            ]
        }
        if (checkedItens.inferiorColumn) {
            const inferiorColumns: Array<{ name: string; elements: Array<ColumnType> }> = copCoi.inferior
            columns.columns_inferior = inferiorColumns?.map((column: { name: string; elements: Array<ColumnType> }) => {
                return {
                    name: name,
                    elements: convertColumns(column.elements)
                }
            })
        }

        completionImportInfo.columns = columns
    }

    completionImportInfo.wellCard = checkedItens

    // wellAttributes
    if (checkedItens.pressures || checkedItens.all) completionImportInfo.pressures = wellFileImport.pressures
    if (checkedItens.trajectory || checkedItens.all) completionImportInfo.trajectory = wellFileImport.trajectory
    if (checkedItens.temperatures || checkedItens.all) completionImportInfo.temperatures = wellFileImport.pressures
    if (checkedItens.lithology || checkedItens.all) completionImportInfo.lithology = wellFileImport.lithology
    if (checkedItens.sections || checkedItens.all) completionImportInfo.sections = wellFileImport.sections

    return completionImportInfo
}

const convertColumns = (column: Array<ColumnType>) => {
    return column?.map((element: ColumnType) => {
        if (element.element_type) {
            element.element_type = element?.element_type.split('/')[1] || ''
            element.type_img = typeImages[element.element_type] || ''
        }
        if (element.element_type === 'tubes') element.element_type = 'COPTubos'

        element.element_component = element?.element_component?.split('/')[1] || ''
        element.element_component_group = element?.element_component_group?.split('/')[1] || ''

        return element
    })
}

export default {
    convertWell,
    convertRigBopFile,
    convertCompletionAbandonment
}
